<!-- <template>
  <div class="row d-flex align-items-center mt-0">
    <div class="col-xl-auto col-lg-auto col-md-auto col-auto">
      <span>

        <img src="../../../public/logo.png" :style="{
          height: '3rem !important',
        }" class="ms-2" />

      </span>
    </div>
    
    <div class="col-xl col-lg col-md col-4 d-xl-flex d-lg-flex d-md-flex d-none">
     
      <NewsTickerVue />
    </div>

    <div
      class="col-xl-auto col-lg-auto col-md-auto col justify-content-end bprder border-primary d-flex align-items-center">
      <span>
        <i class="bi bi-question-circle fs-3"></i>
      </span>
      <span>
        <i class="bi bi-grid-3x3-gap-fill fs-3"></i>
      </span>
      <span>
        <router-link :to="{ name: 'shares-index' }">
          <i class="bi bi-share-fill text-white fs-3"></i>
        </router-link>
      </span>
      <button @click="
        logout_display ? (logout_display = false) : (logout_display = true)
        " class="btn d-flex align-items-center px-1 py-2 text-white rounded">
        <span>
          <i class="bi bi-person-circle fs-3"></i>
        </span>
        <span class="">
          {{ authData.name }}
        </span>
      </button>
      <button @click="logout()" class="btn btn-danger col-auto border  py-2">
        Déconnecter
      </button>
      
    </div>

    <div class="col-xl-auto col-lg-auto col-md-auto col-12">
      <AlertVue class="border"></AlertVue>
    </div>

    <div v-if="logout_display" :style="{
      width: '200px',
      height: '100px',
      position: 'absolute',
      top: '4.3em',
      right: '10px',
      zIndex: 1000,
    }" class="position-absolute p-3 bg-white rounded shadow align-items-end">
      <button @click="logout()" class="btn btn-danger col-auto px-3 py-2">
        Déconnecter
      </button>
    </div>
  </div>
</template>
<script>
import NewsTickerVue from "../cards/NewsTicker.vue";
import AlertVue from "../../views/notification/Alert.vue";
import ChatBotVue from "../cards/ChatBot.vue";
import SearchVue from "../cards/Search.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    NewsTickerVue,
    AlertVue,
    ChatBotVue,
    SearchVue,
  },
  data() {
    return {
      display_sidebar: false,
      logout_display: false,
    };
  },
  computed: {
    ...mapGetters("auth", {
      authData: "getAuthData",
    }),
  },
  mounted() {
    // this.getWindowWidth();
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      // this.$router.push({ name: "login" });
    },

    getWindowWidth() {
      const pageWidth = document.documentElement.clientWidth;
      console.log("Page Width (Vue):", pageWidth, "pixels");
      return pageWidth;
      // You can store this value in a data property if needed.
    },
  },
};
</script> -->


<template>
  <div class="row d-flex align-items-center mt-0">
    <!-- Logo Section -->
    <div class="col-xl-auto col-lg-auto col-md-auto col-auto bg-light rounded p-1 px-2">
      <span >
        <img src="../../../public/logo.png" :style="{ height: '3rem !important' }" class="ms-2 rounded" />
      </span>
    </div>

    <!-- News Ticker Section -->
    <div class="col-xl col-lg col-md col-4 d-xl-flex d-lg-flex d-md-flex d-none">
      <NewsTickerVue /> 
      <!-- app_stock_type : {{ $app_stock_type }} -->
    </div>

    <!-- Header Actions Section -->
    <div class="col-xl-auto col-lg-auto col-md-auto col justify-content-end  shadow-0 d-flex align-items-center">
      <!-- Share Button -->
      <button @click="$router.push({ name: 'settings-index' })"
        class="btn d-flex align-items-center px-1 py-2 text-white rounded">
        <i class="bi bi-gear-wide-connected text-white fs-3"></i>
      </button>



      <!-- Profile Dropdown -->
      <button @click="toggleLogout" class="btn d-flex align-items-center px-1 py-2 text-white rounded">
        <i class="bi bi-person-circle fs-3"></i>
        <span>{{ authData.name }}</span>
      </button>

      <button @click="openShareModal" class="btn d-flex align-items-center px-1 py-2 text-white rounded">
        <i class="bi bi-share-fill text-white fs-3"></i> Partager page
      </button>

      <!-- Logout Button -->
      <!-- <button v-if="logout_display" @click="logout" class="btn btn-danger col-auto border py-2">
        Déconnecter
      </button> -->
    </div>

    <!-- Notification Component -->
    <div class="col-xl-auto col-lg-auto col-md-auto col-12">
      <AlertVue class="border" />
    </div>

    <!-- Logout Confirmation -->
    <div v-if="logout_display" :style="{
      width: '200px',
      height: '100px',
      position: 'absolute',
      top: '4.3em',
      right: '10px',
      zIndex: 1000,
    }" class="position-absolute p-3 bg-white rounded shadow align-items-end">
      <button @click="logout()" class="btn btn-danger col-auto px-3 py-2">
        Déconnecter
      </button>
    </div>

    <!-- Share Modal (using our global modal) -->
    <global-modal :visible="showShareModal" title="Share With User" modal-width="500px" @close="showShareModal = false">

      <template v-slot:body>
        <div>
          <label for="">
            Remarque
          </label>
          <textarea v-model="remark" placeholder="Message" class="form-control">

        </textarea>
        </div>
        <br>
        <!-- <div class="user-search mb-3">
          <input type="text" v-model="searchQuery" placeholder="Search users..." class="form-control">
        </div> -->

        <div class="user-list">
          <div v-for="user in users" :key="user.reference" class="user-item d-flex align-items-center p-2 border-bottom"
            @click="shareWithUser(user)">
            <i class="bi bi-person-circle fs-4 me-3"></i>
            <div>
              <div class="fw-bold text-primary">{{ user.name }}</div>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <button class="btn btn-secondary" @click="showShareModal = false">
          Cancel
        </button>
      </template>
    </global-modal>
  </div>
</template>

<script>
import NewsTickerVue from "../cards/NewsTicker.vue";
import AlertVue from "../../views/notification/Alert.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    NewsTickerVue,
    AlertVue,
  },
  data() {
    return {
      display_sidebar: false,
      logout_display: false,
      showShareModal: false,
      searchQuery: '',
      remark: '',
    };
  },
  computed: {
    ...mapGetters("auth", {
      authData: "getAuthData",
      settings: "getSettings"
    }),
    ...mapGetters("user", {
      users: "getAll",
    }),
    filteredUsers() {
      return this.users.filter(user =>
        user.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    // ...mapActions("share", ["shareWithUser"]),

    toggleLogout() {
      this.logout_display = !this.logout_display;
    },

    logout() {
      this.$store.dispatch("auth/logout");
    },

    openShareModal() {
      this.showShareModal = true;
      this.$store.dispatch('user/getAll');
    },

    shareWithUser(user) {
      const routeData = {
        sharedWith: user.reference,
        routeName: this.$route.name,
        params: this.$route.params,
        query: this.$route.query,
        remark: this.remark,
      };

      this.$store.dispatch('share/store', routeData)
        .then(() => {
          this.$toast.success("Successfully shared!");
          this.showShareModal = false;
        })
        .catch(error => {
          this.$toast.error("Failed to share: " + error.message);
        });
    },

    getWindowWidth() {
      return document.documentElement.clientWidth;
    },
  },
};
</script>

<style scoped>
.user-item {
  cursor: pointer;
  transition: background-color 0.2s;
}

.user-item:hover {
  background-color: #f8f9fa;
}

.user-search {
  margin-bottom: 1rem;
}

/* Add any additional styles you need */
</style>
